const api = require('networkapp-api-connector');

export default {
    toggleFavorite: (user, isFavorite, eventId = null) => {
        const userId = user.user_id || 0,
            participantId = user.participant_id || 0;

        return api.participants.toggleFavorite(userId, participantId, isFavorite).then((response) => {
            app.store.dispatch(app.actions.participants.updateFavorite(eventId, userId, participantId, !!response?.is_favorite));
            return response;
        });
    },
};
